import React from 'react'

const MagnifyingGlassIcon = () => {
	return (
		<svg width={35} height={35} viewBox='0 0 35 35' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<g clipPath='url(#clip0_1539:6269)'>
				<path
					d='M31.723 26.754l-6.39-5.487a14.008 14.008 0 002.2-7.494 13.692 13.692 0 00-4.019-9.752A13.89 13.89 0 0013.767 0 13.676 13.676 0 004.019 4.02 13.901 13.901 0 000 13.773a13.693 13.693 0 004.02 9.751 13.835 13.835 0 0017.294 1.785L27 31.529a3.357 3.357 0 005.456-3.69 3.358 3.358 0 00-.733-1.085zm-25.995-5.04a11.307 11.307 0 017.989-19.3 11.297 11.297 0 0110.44 6.98 11.31 11.31 0 01-2.452 12.32A11.28 11.28 0 019.392 24.17a11.28 11.28 0 01-3.664-2.455z'
					fill='currentColor'
				/>
			</g>
		</svg>
	)
}

export default MagnifyingGlassIcon
